export enum UserPlan {
    Trial = 'Trial',
    Basic = 'Basic',
    Standard = 'Standard',
    Professional = 'Professional',
    Enterprise = 'Enterprise', // billed manually as NET30...
    Corporate = 'Corporate' // billed automatically via Stripe
}

export interface IUserPlan {
    isBasicUser: boolean;
    isCorporateUser: boolean;
    isProfessionalUser: boolean;
    isBetaUser: boolean;
    isTrialUser: boolean;
}
